import { useHasAccess } from '@waitroom/auth';
import { Role } from '@waitroom/models';
import { ReactNode } from 'react';
import { Navigate, PathRouteProps, useLocation } from 'react-router-dom';
import { routes } from '../../../../constants/routes';

export type ProtectedRouteBaseProps = {
  loader?: ReactNode;
  role?: Role;
  to?: string;
  toLogin?: boolean;
  replace?: boolean;
  allowGuest?: boolean;
};
export type ProtectedRouteProps = Omit<PathRouteProps, 'loader'> & ProtectedRouteBaseProps;

const ProtectedRoute = ({
  loader,
  role,
  to,
  toLogin,
  replace = true,
  allowGuest,
  children,
}: ProtectedRouteBaseProps & { children: PathRouteProps['element'] }) => {
  const location = useLocation();
  const { isLoading, isAuthenticated, hasAccess, isGuest } = useHasAccess(role);
  if (isLoading) return <>{loader}</>;
  if (!isAuthenticated || !hasAccess || (!allowGuest && isGuest)) {
    return (
      <Navigate
        replace={replace}
        to={to || (toLogin ? routes.AUTH.LOGIN.link : routes.AUTH.REGISTER.link)}
        state={{ from: location, roles: [role] }}
      />
    );
  }
  return <>{children}</>;
};

export default ProtectedRoute;
